import React, { useState, useMemo, useCallback } from "react";
import { Modal, Form, message } from "antd";
import { connect } from "dva";
import { transferVehicle } from "@/services/shipments";
import TransferVehicleForm from "@/forms/shared/Vehicle/TransferVehicleForm";

const TransferVehicleModal = ({
  transferVehicleId,
  onClose,
  adminShipmentData: modelAdminShipmentData,
  shipmentData: paramShipmentData,
  onVehicleTransferred,
}) => {
  const [formRef] = Form.useForm();
  const [loadingTransferVehicle, setLoadingTransferVehicle] = useState(false);

  const adminShipmentData = useMemo(
    () => paramShipmentData ?? modelAdminShipmentData,
    [modelAdminShipmentData, paramShipmentData],
  );

  const handleTransferVehicle = useCallback(
    ({ shipmentId }) => {
      setLoadingTransferVehicle(true);

      const payload = {
        targetShipmentId: shipmentId,
        originShipmentId: adminShipmentData.id,
      };

      transferVehicle(transferVehicleId, payload)
        .then(res => {
          if (res) {
            onClose();
            formRef.resetFields();
            message.success("Successfully transferred vehicle.");
            onVehicleTransferred?.(transferVehicleId);
          }
        })
        .finally(() => {
          setLoadingTransferVehicle(false);
        });
    },
    [transferVehicleId, adminShipmentData, formRef, onClose, onVehicleTransferred],
  );

  return (
    <Modal
      title="Transfer Vehicle"
      open={!!transferVehicleId}
      onOk={formRef.submit}
      onCancel={() => {
        formRef.resetFields();
        onClose();
      }}
      confirmLoading={loadingTransferVehicle}
    >
      <TransferVehicleForm formRef={formRef} onSubmit={handleTransferVehicle} />
    </Modal>
  );
};

export default connect(({ adminShipmentView }) => ({
  adminShipmentData: adminShipmentView?.data,
}))(TransferVehicleModal);
